module.exports = __webpack_public_path__ + "static/media/refresh_black.986bef7e.svg";